import { useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";

export default function BeforeAfterSlider({ before, after, label }) {
  const [pos, setPos] = useState(50);
  const [ratio, setRatio] = useState(null);
  const ref = useRef(null);
  const dragging = useRef(false);

  const update = (clientX) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  };

  const onDown = (e) => { dragging.current = true; update(e.clientX); };
  const onMove = (e) => { if (dragging.current) update(e.clientX); };
  const onUp = () => { dragging.current = false; };

  return (
    <div className="rounded-2xl overflow-hidden border border-border bg-white shadow-sm" data-testid={`ba-slider-${(label || "").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
      <div
        ref={ref}
        className="relative select-none touch-none cursor-ew-resize bg-black"
        style={{ touchAction: "none", aspectRatio: ratio || "1 / 1" }}
        onPointerDown={onDown}
        onPointerMove={onMove}
        onPointerUp={onUp}
        onPointerLeave={onUp}
      >
        <img
          src={after}
          alt={`${label} after`}
          draggable={false}
          onLoad={(e) => { const { naturalWidth: w, naturalHeight: h } = e.target; if (w && h) setRatio(`${w} / ${h}`); }}
          className="absolute inset-0 w-full h-full object-cover"
        />
        <img src={before} alt={`${label} before`} draggable={false} className="absolute inset-0 w-full h-full object-cover" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} />

        <span className="absolute top-3 left-3 text-[10px] font-semibold uppercase tracking-wider bg-secondary/90 text-white rounded-full px-2.5 py-1">Before</span>
        <span className="absolute top-3 right-3 text-[10px] font-semibold uppercase tracking-wider bg-accent text-white rounded-full px-2.5 py-1">After</span>

        <div className="absolute top-0 bottom-0 w-0.5 bg-white shadow-[0_0_8px_rgba(0,0,0,0.3)]" style={{ left: `${pos}%` }}>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center text-primary">
            <MoveHorizontal className="w-5 h-5" />
          </div>
        </div>
      </div>
      <div className="px-4 py-3 flex items-center justify-between">
        <span className="text-sm font-semibold">{label}</span>
        <span className="text-xs text-muted-foreground">Drag to reveal</span>
      </div>
    </div>
  );
}
